'use client';

/**
 * Stub `SessionProvider` for the landing app.
 *
 * Background: the landing site has no NextAuth route and no real
 * concept of "logged in" (cookies live on app.formsuite.co). But
 * shared client hooks like `useTrack` (and any other consumer of
 * `useSession`) still call `useSession()` unconditionally — and
 * NextAuth's `useSession` throws if it can't find a `SessionProvider`
 * ancestor.
 *
 * Solution: wrap the tree in a `SessionProvider` that's pre-seeded
 * with `session={null}`, with all refetching disabled. This gives
 * `useSession` a stable `{ data: null, status: 'unauthenticated' }`
 * return without ever hitting `/api/auth/session` (which would 404,
 * since we removed the NextAuth route from this app).
 *
 * Net effect: zero network cost, zero DB calls, all shared hooks
 * keep working.
 */
import { SessionProvider } from 'next-auth/react';

export function PublicSessionShell({ children }: { children: React.ReactNode }) {
  return (
    <SessionProvider
      session={null}
      refetchInterval={0}
      refetchOnWindowFocus={false}
    >
      {children}
    </SessionProvider>
  );
}
